import React, { useState, useEffect, useRef } from 'react';
import { Users, FileQuestion, Target, Clock, Pin, UserPlus, ChevronDown, ChevronRight, Search, PinOff, FolderPlus } from 'lucide-react';
import { useRecoilState } from 'recoil';
//import { logEventsState } from '../../store/atoms';
import PromptBar from './PromptBar';
import Sidebar_v2 from '../sidebar/Sidebar_v2';

import { pinnedQueriesState, tableLoadingState } from '../../store/atoms';
import { useRecoilValue, useSetRecoilState } from "recoil";
import { logEvent } from '../../cloudwatchLogger';
import config from '../../config';
import useLambda from '../hooks/useLambda';
import AWS from 'aws-sdk';
import { awsExports } from '../../aws-exports';
import { useMediaQuery } from '@mui/material';
import { conversationIdState } from '../../store/atoms';
import { firstNameState, displayRoleState, selectedTeamState } from "../../store/atoms";

// Lambda invoker utility
const invokeLambda = async (action, payload, lambda, lambdaFunctionName) => {
  //console.log('action is : '+action);
  const params = {
    FunctionName: lambdaFunctionName,
    InvocationType: 'RequestResponse',
    Payload: JSON.stringify({ action, payload })
  };
  // console.log('params are: ' + JSON.stringify(params));
  try {
    const response = await lambda.invoke(params).promise();
    const result = JSON.parse(response.Payload);
    //console.log('result from the lambda is: '+JSON.stringify(result.data));
    if (!result.success) throw new Error(result.error);
    return result.data;
  } catch (error) {
    console.error(`Error invoking Lambda (${action}):`, error);
    throw error;
  }
};

  const TargetedSearch = ({setSelectedQuery}) => {
    //const [selectedQuery, setSelectedQuery] = useState('');
    const pinnedQueries = useRecoilValue(pinnedQueriesState);
    const setPinnedQueries = useSetRecoilState(pinnedQueriesState);
    const [managedQueries, setManagedQueries] = useState([]);
    const [tenantGroup, setTenantGroup] = useState([]);
    const [loading, setLoading] = useState(true);
    const [jwtToken, setJwtToken] = useState('');
    const [sub, setSub] = useState('');
    const { decodeToken, getJWT, configureLambda } = useLambda();
    const pageRef = useRef(null);
    const [tableLoading, setTableLoading] = useRecoilState(tableLoadingState);
    const [lambdaFunctionName] = useState(awsExports.Lambda.queryManagement);
    const [tenantMgmtFunctionName] = useState(awsExports.Lambda.userManagement);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [isTenantAdmin, setIsTenantAdmin] = useState(false);
    const isMobile = useMediaQuery('(max-width:768px)');

    const [conversationId, setConversationId] = useRecoilState(conversationIdState);
    const [selectedTeam, setSelectedTeam] = useRecoilState(selectedTeamState);
    
    useEffect(() => {
      

          const fetchTokenAndSub = async () => {
            const jwtToken = await getJWT();
            await configureLambda(jwtToken);
            const lambda = new AWS.Lambda();
      
            const payload = {
              jwtToken,
              operation: 'getRequestedTokenFields',
              requested_items: ['sub', 'cognito:groups'],
            };
      
            const stringifiedPayload = JSON.stringify(payload);
            const params = {
              FunctionName: tenantMgmtFunctionName,
              Payload: stringifiedPayload,
            };
      
            try {
              const result = await lambda.invoke(params).promise();
              const data = typeof result.Payload === 'string' ? JSON.parse(result.Payload) : result.Payload;
              const bodyData = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
              // console.log('bodyData is : '+JSON.stringify(bodyData));
              const tenantgroup = bodyData['cognito:groups'] || [];
              let filteredGroups = tenantgroup.includes("Tenants") ? tenantgroup.filter(group => group !== 'Tenants') : [...tenantgroup];
              setTenantGroup(filteredGroups);
              setIsSuperAdmin(bodyData.isSuperAdmin);
              setIsTenantAdmin(bodyData.isTenantAdmin);
              setSub(bodyData.sub);
            } catch (error) {
              console.error('Error invoking getRequestedTokenFields Lambda:', error);
              throw error;
            }
          };
      fetchTokenAndSub();
      setConversationId('');
    }, []);
  
    useEffect(() => {
      const fetchSavedQueries = async () => {
        if (!sub) return;
        try {
          const jwtToken = await getJWT();
          const requested_items = ['sub'];
          const lambda = new AWS.Lambda();
          const data = await invokeLambda('getSavedQueries', { created_by: sub, jwtToken: jwtToken, requested_items: requested_items}, lambda, lambdaFunctionName);
          setManagedQueries(data);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching saved queries:', error);
          setLoading(false);
        }
      };
  
      const fetchUserSavedQueries = async () => {
        //console.log("inside fetch user saved queries");
        if (!selectedTeam) return;
        try {
          //console.log(`tenant group inside fetch user group is : ${tenantGroup}`);
          const lambda = new AWS.Lambda();
          const data = await invokeLambda('getUserSavedQueries', { 'groupname':selectedTeam[0] }, lambda, lambdaFunctionName);
          setManagedQueries(data);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching saved queries:', error);
          setLoading(false);
        }
      };
  
      if (isSuperAdmin || isTenantAdmin) {
        fetchSavedQueries();
      } else if (selectedTeam.length > 0) {
        fetchUserSavedQueries();
      }
    }, [sub, isSuperAdmin, isTenantAdmin, selectedTeam]);
  
// Function to handle dynamic transformation
const transformDatabaseResults = (dbResults) => {
  const transformedResults = dbResults.map((result, index) => ({
    text: result.query_name,
    isPinned: true,
    id: result.id
  }));
  setPinnedQueries(transformedResults);
};
//console.log('pinned queries are: '+JSON.stringify(pinnedQueries));

  const handleQueryClick = (query) => {
    setSelectedQuery(query);
    logEvent({ eventType: 'querySelected', details: `Selected query: ${query}` });
  };

  const handlePinToggle = (id) => {
    const queryToToggle = pinnedQueries.find(query => query.id === id);
    if (!queryToToggle) return;
    if (queryToToggle.isPinned) {
      // Unpin the query and call delete function
      deleteQuery(id);
    }
  }

  const deleteQuery = async (id) => {
    // console.log(`Deleting query with id: ${id}`);
  
    const updatedQueries = pinnedQueries.filter((query) => query.id !== id);
    setPinnedQueries(updatedQueries);
    const lambda = new AWS.Lambda();
    const jwtToken = await getJWT();
    const data = await invokeLambda('deletePrompts',{ 'id':id, jwtToken: jwtToken }, lambda, lambdaFunctionName);
        // setAvailableQueries(data);
    //console.log('print all prompts'+ JSON.stringify(data));
  
    setTimeout(() => {
      logEvent({ eventType: 'queryUnpinned', details: `Unpinned query with id: ${id}` });
    }, 0);
  };

  const scrollToBottom = () => {
    if (pageRef.current) {
      pageRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  };

  //console.log('managed queries are: '+managedQueries);

  const pinnedQueryCards = pinnedQueries.filter(query => query.isPinned);

  useEffect(() => {
    const fetchPrompts = async () => {
      //console.log("this is sub:" + sub)
      if (!sub) return;
      try {
        const lambda = new AWS.Lambda();
        const jwtToken = await getJWT();
        const requested_items = ['sub'];
        const data = await invokeLambda('getPrompts',{ 'created_by':sub, jwtToken: jwtToken, requested_items: requested_items }, lambda, lambdaFunctionName);
        // setAvailableQueries(data);
        //console.log('print all prompts'+ JSON.stringify(data));
        transformDatabaseResults(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching queries:', error);
        setLoading(false);
      }
    };
    fetchPrompts()
    }, [sub]);

    function SuggestionCard({ data, handleQueryClick, handlePinToggle }) {
      return (
        <div
          className="flex items-start gap-[40px] self-stretch w-[323px] h-[88px] p-5 bg-[#F2F2F2] rounded-[14px] border border-solid border-[#D9D9D9] shadow-[2px_2px_8px_0px_rgba(0,0,0,0.10)] cursor-pointer transition-all duration-300 hover:bg-[#FDF7E7] hover:border-[#EBAE12] group"
          onClick={() => handleQueryClick(data.text)}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              handlePinToggle(data.id);
            }}
            className="focus:outline-none p-0 w-6 h-6 flex items-center justify-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M3 21L8 16" stroke="#8E8E8E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M13.2585 18.8714C9.51516 18.0215 5.97844 14.4848 5.12853 10.7415C4.99399 10.1489 4.92672 9.85266 5.12161 9.37197C5.3165 8.89129 5.55457 8.74255 6.03071 8.44509C7.10705 7.77265 8.27254 7.55888 9.48209 7.66586C11.1793 7.81598 12.0279 7.89104 12.4512 7.67048C12.8746 7.44991 13.1622 6.93417 13.7376 5.90269L14.4664 4.59604C14.9465 3.73528 15.1866 3.3049 15.7513 3.10202C16.316 2.89913 16.6558 3.02199 17.3355 3.26771C18.9249 3.84236 20.1576 5.07505 20.7323 6.66449C20.978 7.34417 21.1009 7.68401 20.898 8.2487C20.6951 8.8134 20.2647 9.05346 19.4039 9.53358L18.0672 10.2792C17.0376 10.8534 16.5229 11.1406 16.3024 11.568C16.0819 11.9955 16.162 12.8256 16.3221 14.4859C16.4399 15.7068 16.2369 16.88 15.5555 17.9697C15.2577 18.4458 15.1088 18.6839 14.6283 18.8786C14.1477 19.0733 13.8513 19.006 13.2585 18.8714Z" stroke="#8E8E8E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <p className="font-inter text-[#8E8E8E] group-hover:text-black flex-grow">
            {data.text}
          </p>
        </div>
      );
    }
  
    function EmptyQueryCard({ type }) {
      return (
        <div 
          className="flex items-start gap-[23px] flex-1 self-stretch"
          style={{
            display: 'flex',
            padding: '21px',
            borderRadius: '14px',
            background: 'var(--Foundation-Primary-black-Light, #F2F2F2)'
          }}
        >
          <div 
            className="flex"
            style={{
              width: '24px',
              height: '24px',
              padding: '2px'
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M3 21L8 16" stroke="#8E8E8E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M13.2585 18.8714C9.51516 18.0215 5.97844 14.4848 5.12853 10.7415C4.99399 10.1489 4.92672 9.85266 5.12161 9.37197C5.3165 8.89129 5.55457 8.74255 6.03071 8.44509C7.10705 7.77265 8.27254 7.55888 9.48209 7.66586C11.1793 7.81598 12.0279 7.89104 12.4512 7.67048C12.8746 7.44991 13.1622 6.93417 13.7376 5.90269L14.4664 4.59604C14.9465 3.73528 15.1866 3.3049 15.7513 3.10202C16.316 2.89913 16.6558 3.02199 17.3355 3.26771C18.9249 3.84236 20.1576 5.07505 20.7323 6.66449C20.978 7.34417 21.1009 7.68401 20.898 8.2487C20.6951 8.8134 20.2647 9.05346 19.4039 9.53358L18.0672 10.2792C17.0376 10.8534 16.5229 11.1406 16.3024 11.568C16.0819 11.9955 16.162 12.8256 16.3221 14.4859C16.4399 15.7068 16.2369 16.88 15.5555 17.9697C15.2577 18.4458 15.1088 18.6839 14.6283 18.8786C14.1477 19.0733 13.8513 19.006 13.2585 18.8714Z" stroke="#8E8E8E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div 
            className="flex-1 text-[#8E8E8E]"
            style={{
              fontFamily: 'Inter',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '120%',
              padding: '20 23px'
            }}
          >
            {type === 'pinned' ? 'No pinned query' : 'No managed query'}
          </div>
        </div>
      );
    }

    if(tableLoading) {
      return (
        <div className="w-full flex justify-center items-center">
          <div className="relative">
            <img
              src="update_table_loader2.svg"
              alt="Loading..."
              style={{
                width: '869px',
                height: '434px'
              }}
            />
          </div>
        </div>
      );
    };
    

    // Calculate how many empty cards we need to add
    const totalCards = pinnedQueries.length;
    const emptyCardsNeeded = totalCards === 0 ? 3 : (3 - (totalCards % 3)) % 3;
  
    // Create empty cards array
    const emptyCards = Array(emptyCardsNeeded).fill(null);

    const EmptyCard = ({ type }) => {
      const config = {
        pinned: {
          icon: {
            path1: "M3 21L8 16",
            path2: "M13.2585 18.8714C9.51516 18.0215 5.97844 14.4848 5.12853 10.7415C4.99399 10.1489 4.92672 9.85266 5.12161 9.37197C5.3165 8.89129 5.55457 8.74255 6.03071 8.44509C7.10705 7.77265 8.27254 7.55888 9.48209 7.66586C11.1793 7.81598 12.0279 7.89104 12.4512 7.67048C12.8746 7.44991 13.1622 6.93417 13.7376 5.90269L14.4664 4.59604C14.9465 3.73528 15.1866 3.3049 15.7513 3.10202C16.316 2.89913 16.6558 3.02199 17.3355 3.26771C18.9249 3.84236 20.1576 5.07505 20.7323 6.66449C20.978 7.34417 21.1009 7.68401 20.898 8.2487C20.6951 8.8134 20.2647 9.05346 19.4039 9.53358L18.0672 10.2792C17.0376 10.8534 16.5229 11.1406 16.3024 11.568C16.0819 11.9955 16.162 12.8256 16.3221 14.4859C16.4399 15.7068 16.2369 16.88 15.5555 17.9697C15.2577 18.4458 15.1088 18.6839 14.6283 18.8786C14.1477 19.0733 13.8513 19.006 13.2585 18.8714Z",
            width: 24,
            stroke: "#BDBDBD"
          },
          text: "Pin a query during search to keep frequently used queries prioritized"
        },
        managed: {
          icon: {
            path1: "M5.51991 13.2057C5.28876 13.1123 5.16109 13.067 5.08968 13.0758C5.00191 13.0865 4.87457 13.18 4.61988 13.3669C4.17082 13.6965 3.60509 13.9332 2.76613 13.9129C2.3419 13.9026 2.12978 13.8974 2.03482 13.7363C1.93986 13.5752 2.05813 13.3521 2.29467 12.906C2.62272 12.2873 2.83058 11.579 2.51562 11.0115C1.97319 10.2008 1.51243 9.24083 1.4451 8.20398C1.40893 7.64687 1.40893 7.06993 1.4451 6.51284C1.62997 3.666 3.87663 1.39835 6.69712 1.21176C7.65739 1.14823 8.66202 1.1481 9.62429 1.21176C12.4328 1.39756 14.6723 3.64676 14.8738 6.47656",
            path2: "M10.4134 15.0808C8.63564 14.9668 7.21954 13.581 7.10302 11.8413C7.08024 11.5008 7.08024 11.1483 7.10302 10.8078C7.21954 9.06803 8.63564 7.68224 10.4134 7.5682C11.02 7.52931 11.6532 7.52938 12.2585 7.5682C14.0363 7.68224 15.4524 9.06803 15.5689 10.8078C15.5916 11.1483 15.5916 11.5008 15.5689 11.8413C15.5264 12.4749 15.236 13.0616 14.8941 13.5569C14.6956 13.9037 14.8266 14.3366 15.0334 14.7147C15.1825 14.9874 15.257 15.1236 15.1971 15.2221C15.1373 15.3206 15.0036 15.3237 14.7362 15.33C14.2074 15.3424 13.8508 15.1978 13.5678 14.9964C13.4073 14.8822 13.3269 14.8251 13.2716 14.8185C13.2163 14.8119 13.1074 14.8552 12.8897 14.9417C12.6941 15.0194 12.4669 15.0675 12.2585 15.0808C11.6532 15.1197 11.02 15.1197 10.4134 15.0808Z",
            width: 17,
            stroke: "#8E8E8E"
          },
          text: "Administrator managed query"
        }
      };
    
      const { icon, text } = config[type];
    
      return (
        <div className="flex w-[230px] p-5 flex-col items-center gap-[15px] rounded-[14px] border border-[#D9D9D9] bg-[#F2F2F2]">
          <svg xmlns="http://www.w3.org/2000/svg" width={icon.width} height={icon.width} viewBox="0 0 24 24" fill="none">
            <path d={icon.path1} stroke={icon.stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d={icon.path2} stroke={icon.stroke} strokeWidth="1.5" strokeLinejoin="round"/>
          </svg>
          <p className="text-[#BDBDBD] text-center font-inter text-base font-normal">
            {text}
          </p>
        </div>
      );
    };
    
    const getEmptyCards = (queries, type) => {
      const totalCards = queries.length;
      const emptyCardsNeeded = totalCards === 0 ? 3 : (3 - (totalCards % 3)) % 3;
      return Array(emptyCardsNeeded).fill(null).map((_, index) => (
        <EmptyCard key={`empty-${type}-${index}`} type={type} />
      ));
    };

    return (
      <div class="flex flex-col w-[45.75rem] items-start gap-[3.75rem]">
        {/* Pinned Queries Section */}
        <div className="flex flex-col gap-5 self-stretch">
        <div className="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M3 21L8 16" stroke="#EBAE12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M13.2585 18.8714C9.51516 18.0215 5.97844 14.4848 5.12853 10.7415C4.99399 10.1489 4.92672 9.85266 5.12161 9.37197C5.3165 8.89129 5.55457 8.74255 6.03071 8.44509C7.10705 7.77265 8.27254 7.55888 9.48209 7.66586C11.1793 7.81598 12.0279 7.89104 12.4512 7.67048C12.8746 7.44991 13.1622 6.93417 13.7376 5.90269L14.4664 4.59604C14.9465 3.73528 15.1866 3.3049 15.7513 3.10202C16.316 2.89913 16.6558 3.02199 17.3355 3.26771C18.9249 3.84236 20.1576 5.07505 20.7323 6.66449C20.978 7.34417 21.1009 7.68401 20.898 8.2487C20.6951 8.8134 20.2647 9.05346 19.4039 9.53358L18.0672 10.2792C17.0376 10.8534 16.5229 11.1406 16.3024 11.568C16.0819 11.9955 16.162 12.8256 16.3221 14.4859C16.4399 15.7068 16.2369 16.88 15.5555 17.9697C15.2577 18.4458 15.1088 18.6839 14.6283 18.8786C14.1477 19.0733 13.8513 19.006 13.2585 18.8714Z" stroke="#EBAE12" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <p className="text-[#EBAE12] font-inter text-xl font-bold text-center" style={{ fontFamily: 'Inter', fontSize: '13px', fontWeight: '700', lineHeight: '120%' }}>
            Pinned Queries
          </p>
        </div>
        <div className="flex flex-wrap gap-5 w-full justify-center">
          {pinnedQueries.map((query) => (
            <div
              key={query.id}
              className="flex w-[230px] p-5 flex-col items-center gap-[15px] rounded-[14px] border border-[#F9E6B6] bg-white shadow-[0px_2px_20px_0px_rgba(0,0,0,0.16)] cursor-pointer hover:bg-[#FDF7E7] hover:border-[#D99E10] group transition-all duration-200"
              onClick={() => setSelectedQuery(query.text)}
            >
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handlePinToggle(query.id);
                }}
                className="group focus:outline-none p-0 w-6 h-6 flex items-center justify-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M3 21L8 16" className="stroke-[#EBAE12]" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M13.2585 18.8714C9.51516 18.0215 5.97844 14.4848 5.12853 10.7415C4.99399 10.1489 4.92672 9.85266 5.12161 9.37197C5.3165 8.89129 5.55457 8.74255 6.03071 8.44509C7.10705 7.77265 8.27254 7.55888 9.48209 7.66586C11.1793 7.81598 12.0279 7.89104 12.4512 7.67048C12.8746 7.44991 13.1622 6.93417 13.7376 5.90269L14.4664 4.59604C14.9465 3.73528 15.1866 3.3049 15.7513 3.10202C16.316 2.89913 16.6558 3.02199 17.3355 3.26771C18.9249 3.84236 20.1576 5.07505 20.7323 6.66449C20.978 7.34417 21.1009 7.68401 20.898 8.2487C20.6951 8.8134 20.2647 9.05346 19.4039 9.53358L18.0672 10.2792C17.0376 10.8534 16.5229 11.1406 16.3024 11.568C16.0819 11.9955 16.162 12.8256 16.3221 14.4859C16.4399 15.7068 16.2369 16.88 15.5555 17.9697C15.2577 18.4458 15.1088 18.6839 14.6283 18.8786C14.1477 19.0733 13.8513 19.006 13.2585 18.8714Z" className="stroke-[#EBAE12]" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <p className="text-[#EBAE12] text-center font-inter text-base group-hover:font-bold transition-all duration-200">
                {query.text}
              </p>
            </div>
          ))}
          {getEmptyCards(pinnedQueries, 'pinned')}
        </div>
      </div>

  
        {/* Managed Queries Section */}
        <div className="flex flex-col gap-5 self-stretch">
      <div className="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M5.51991 13.2057C5.28876 13.1123 5.16109 13.067 5.08968 13.0758C5.00191 13.0865 4.87457 13.18 4.61988 13.3669C4.17082 13.6965 3.60509 13.9332 2.76613 13.9129C2.3419 13.9026 2.12978 13.8974 2.03482 13.7363C1.93986 13.5752 2.05813 13.3521 2.29467 12.906C2.62272 12.2873 2.83058 11.579 2.51562 11.0115C1.97319 10.2008 1.51243 9.24083 1.4451 8.20398C1.40893 7.64687 1.40893 7.06993 1.4451 6.51284C1.62997 3.666 3.87663 1.39835 6.69712 1.21176C7.65739 1.14823 8.66202 1.1481 9.62429 1.21176C12.4328 1.39756 14.6723 3.64676 14.8738 6.47656" stroke="#40C5AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10.4134 15.0808C8.63564 14.9668 7.21954 13.581 7.10302 11.8413C7.08024 11.5008 7.08024 11.1483 7.10302 10.8078C7.21954 9.06803 8.63564 7.68224 10.4134 7.5682C11.02 7.52931 11.6532 7.52938 12.2585 7.5682C14.0363 7.68224 15.4524 9.06803 15.5689 10.8078C15.5916 11.1483 15.5916 11.5008 15.5689 11.8413C15.5264 12.4749 15.236 13.0616 14.8941 13.5569C14.6956 13.9037 14.8266 14.3366 15.0334 14.7147C15.1825 14.9874 15.257 15.1236 15.1971 15.2221C15.1373 15.3206 15.0036 15.3237 14.7362 15.33C14.2074 15.3424 13.8508 15.1978 13.5678 14.9964C13.4073 14.8822 13.3269 14.8251 13.2716 14.8185C13.2163 14.8119 13.1074 14.8552 12.8897 14.9417C12.6941 15.0194 12.4669 15.0675 12.2585 15.0808C11.6532 15.1197 11.02 15.1197 10.4134 15.0808Z" stroke="#40C5AF" strokeWidth="1.5" strokeLinejoin="round"/>
        </svg>
        <p className="text-[#40C5AF] font-inter text-xl font-bold text-center" style={{ fontFamily: 'Inter', fontSize: '13px', fontWeight: '700', lineHeight: '120%' }}>
          Managed Queries
        </p>
      </div>
      <div className="flex flex-wrap gap-5 w-full justify-center"> 
        {managedQueries.map((query) => (
          <div
            key={query.id}
            className="flex w-[230px] p-5 flex-col items-center gap-[15px] rounded-[14px] border border-[#C4EDE6] bg-white shadow-[0px_2px_20px_0px_rgba(0,0,0,0.16)] cursor-pointer hover:bg-[#d9f3ef] hover:border-[#35A694] group transition-all duration-200"
            onClick={() => setSelectedQuery(query.query_name)}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                handlePinToggle(query.id);
              }}
              className="group focus:outline-none p-0 w-6 h-6 flex items-center justify-center"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M5.51991 13.2057C5.28876 13.1123 5.16109 13.067 5.08968 13.0758C5.00191 13.0865 4.87457 13.18 4.61988 13.3669C4.17082 13.6965 3.60509 13.9332 2.76613 13.9129C2.3419 13.9026 2.12978 13.8974 2.03482 13.7363C1.93986 13.5752 2.05813 13.3521 2.29467 12.906C2.62272 12.2873 2.83058 11.579 2.51562 11.0115C1.97319 10.2008 1.51243 9.24083 1.4451 8.20398C1.40893 7.64687 1.40893 7.06993 1.4451 6.51284C1.62997 3.666 3.87663 1.39835 6.69712 1.21176C7.65739 1.14823 8.66202 1.1481 9.62429 1.21176C12.4328 1.39756 14.6723 3.64676 14.8738 6.47656" stroke="#40C5AF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10.4134 15.0808C8.63564 14.9668 7.21954 13.581 7.10302 11.8413C7.08024 11.5008 7.08024 11.1483 7.10302 10.8078C7.21954 9.06803 8.63564 7.68224 10.4134 7.5682C11.02 7.52931 11.6532 7.52938 12.2585 7.5682C14.0363 7.68224 15.4524 9.06803 15.5689 10.8078C15.5916 11.1483 15.5916 11.5008 15.5689 11.8413C15.5264 12.4749 15.236 13.0616 14.8941 13.5569C14.6956 13.9037 14.8266 14.3366 15.0334 14.7147C15.1825 14.9874 15.257 15.1236 15.1971 15.2221C15.1373 15.3206 15.0036 15.3237 14.7362 15.33C14.2074 15.3424 13.8508 15.1978 13.5678 14.9964C13.4073 14.8822 13.3269 14.8251 13.2716 14.8185C13.2163 14.8119 13.1074 14.8552 12.8897 14.9417C12.6941 15.0194 12.4669 15.0675 12.2585 15.0808C11.6532 15.1197 11.02 15.1197 10.4134 15.0808Z" stroke="#40C5AF" strokeWidth="1.5" strokeLinejoin="round"/>
              </svg>
            </button>
            <p className="text-[#40C5AF] text-center font-inter text-base group-hover:font-bold transition-all duration-200">
              {query.query_name}
            </p>
          </div>
        ))}
        {getEmptyCards(managedQueries, 'managed')}
      </div>
    </div>
      </div>
    );
  };
  
  export default TargetedSearch;